import React from "react";
import PropTypes from "prop-types";
import Modal from "react-modal";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardFooter,
  Form,
  FormGroup,
  FormFeedback,
  Label,
  Input,
  Col,
} from "reactstrap";
import { css } from "react-emotion";
import { Formik } from "formik";
import UploadButton from "../KeyRecoveryRequest/UploadButton";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { dateFormatter } from "@/util/formatter";
import { validatePhoneOrEmail } from "@/util/validationHelper";
import { getBase64 } from "@/util/fileToBase64";
import verificationApi from "@/api/verification";
import swal from "sweetalert2";
import { handleError } from "@/util/errorHandler";
import { MAX_FILE_SIZE_IN_BYTES, IS_TOURIST_PG } from "@/store/constants";
import { APP_CONST, getStoredItem } from "@/store/dataStore";
import InputMask from "react-input-mask";

const modalStyles = css`
  position: absolute;
  top: 50%;
  left: 50%;
  right: auto;
  bottom: auto;
  overflow: visible;
  margin-right: -50%;
  transform: translate(-50%, -50%);
  width: 35rem;

  .buttons {
    display: flex;
    justify-content: space-between;
    margin: 15px 0 0;
  }
`;

const overlayStyles = css`
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background-color: rgba(255, 255, 255, 0.75);
  z-index: 1021; /* above navs, below sweetalert */
`;

const datePickerWrapper = css`
  width: 100%;
`;

const displayBlock = css`
  display: block;
`;

// Detail API dates come as [y, m, d]; build a local date so no day shift.
const arrayToDate = date =>
  Array.isArray(date) ? new Date(date[0], date[1] - 1, date[2]) : null;

class UpdateAccountModal extends React.Component {
  state = {
    userPhotoFile: null,
    idPhotoFile: null,
    birthday: null,
  };

  baseState = {
    ...this.state,
  };

  validateFormik = ({
    documentId,
    dateOfBirth: birthday,
    nationality,
    email,
    address,
    sex,
    firstName,
    lastName,
    issuingCountry,
  }) => {
    const errors = {};

    if (!firstName) {
      errors.firstName = "Please enter user's first name";
    }

    if (firstName && firstName.length && !/^[a-zA-Z0-9]+$/g.test(firstName)) {
      errors.firstName =
        "Incorrect first name. The first name should contain [a-zA-Z0-9] ";
    }

    if (firstName && firstName.length > 70) {
      errors.firstName = "First name must not be over 70 characters";
    }

    if (!lastName) {
      errors.lastName = "Please enter user's last name";
    }

    if (
      lastName &&
      lastName.length &&
      !/^[a-zA-Z0-9]+(?: [a-zA-Z0-9]+)?$/g.test(lastName)
    ) {
      errors.lastName =
        "Incorrect last name. The last name should contain [a-zA-Z0-9]";
    }

    if (lastName && lastName.length > 70) {
      errors.lastName = "Last name must not be over 70 characters";
    }

    if (!nationality) {
      errors.nationality = "Please enter user's nationality";
    }
    if (
      nationality &&
      nationality.length &&
      !/^[a-zA-Z0-9]+$/g.test(nationality)
    ) {
      errors.nationality =
        "Incorrect nationality. The nationality should contain [a-zA-Z0-9]";
    }

    if (email && email.length) {
      const registeredType = getStoredItem(APP_CONST.REGISTRATION_TYPE);
      errors.email = validatePhoneOrEmail(email, registeredType !== "SMS");
      if (errors.email === null) {
        delete errors.email;
      }
    }

    // if (!sex) {
    //   errors.sex = "Please enter user's gender";
    // }

    if (!birthday && !this.state.birthday) {
      errors.birthday = "Please enter user's birthday";
    }

    if (!documentId) {
      errors.documentId = "Please enter user's document id";
    }
    if (
      documentId &&
      documentId.length &&
      !/^[a-zA-Z0-9]+$/g.test(documentId)
    ) {
      errors.documentId =
        "Incorrect document ID. The document ID should contain [a-zA-Z_0-9] ";
    }

    if (issuingCountry && !/^[A-Z]{3}$/.test(issuingCountry)) {
      errors.issuingCountry =
        "Issuing country must be 3 uppercase letters (ISO alpha-3, e.g. KHM)";
    }

    return errors;
  };

  onSelectUserPhoto = file => {
    this.setState({ userPhotoFile: file });
  };

  onSelectUserID = file => {
    this.setState({ idPhotoFile: file });
  };

  onSelectDate = (date, callback) => {
    const currentYear = new Date().getFullYear();
    const year =
      new Date(date).getFullYear() > currentYear
        ? currentYear
        : new Date(date).getFullYear();
    const newDate = new Date(date).setFullYear(year);

    this.setState(
      {
        birthday: newDate,
      },
      callback,
    );
  };

  prepareDataBeforeSubmit = async form => {
    const registeredType = getStoredItem(APP_CONST.REGISTRATION_TYPE);
    const _formatDay = date => {
      const _date = new Date(date);
      const _checkLen = v => (v > 9 ? v : `0${v}`);
      const mm = _checkLen(_date.getMonth() + 1);
      const dd = _checkLen(_date.getDate());
      return `${_date.getFullYear()}-${mm}-${dd}`;
    };
    const _formatDate = date => {
      if (!date) return;
      return `${_formatDay(date)} 00:00:00`;
    };

    const {
      birthday: dateOfBirth,
      userPhotoFile: photo,
      idPhotoFile: identity,
    } = this.state;

    const { accountId } = this.props.data;

    var secondaryContact = "";
    if (form.email) {
      secondaryContact = form.email.replace(/\+/g, "").replace(/\s/g, "");
      if (registeredType === "SMS") {
        secondaryContact = form.email.replace(/\+855/g, "").replace(/\s/g, "");
      }
    }
    var params = Object.assign({}, form);
    if ("email" in params) delete params.email;
    // A missing key keeps the stored value; the input only exists on TOUR PG.
    if (!IS_TOURIST_PG) delete params.issuingCountry;

    return {
      accountId,
      ...params,
      sex: form.sex || "male",
      secondaryContact: secondaryContact,
      dateOfBirth: _formatDate(dateOfBirth),
      // "" clears the stored value.
      documentExpiry: form.documentExpiry
        ? _formatDay(form.documentExpiry)
        : "",
      photo: photo ? await getBase64(photo) : undefined,
      identity: identity ? await getBase64(identity) : undefined,
    };
  };

  onUpdateAccount = async form => {
    const data = await this.prepareDataBeforeSubmit(form);
    try {
      const res = await verificationApi.updateUserAccount(data);
      this.props.data.verificationRequestId = res.verificationRequestId;
      this.props.onUpdated();
      swal(
        "Success",
        `Information of ${data.firstName} ${data.lastName} has been changed successfully`,
        "success",
      );
    } catch (error) {
      handleError(error);
    }
  };

  reset = () => {
    this.setState(this.baseState);
  };

  beforeClose = () => {
    this.reset();
    this.props.onModalClose();
  };

  render() {
    const {
      accountId,
      documentId,
      birthday,
      nationality,
      address,
      sex,
      secondaryContact,
      fullName,
      documentExpiry,
      issuingCountry,
    } = this.props.data;
    var firstName = "";
    var lastName = "";
    if (fullName) {
      firstName = fullName.split(" ")[0];
      lastName = fullName.split(" ")[1];
      // in case for user with more than 2 words in name
      if (fullName.split(" ").length > 2) {
        for (var i = 2; i < fullName.split(" ").length; i++) {
          lastName = lastName + " " + fullName.split(" ")[i];
        }
      }
    }
    const registeredType = getStoredItem(APP_CONST.REGISTRATION_TYPE);
    const form = (
      <Formik
        initialValues={{
          accountId,
          documentId,
          dateOfBirth: birthday,
          nationality,
          email: secondaryContact,
          address,
          sex,
          firstName,
          lastName,
          documentExpiry: arrayToDate(documentExpiry),
          issuingCountry: issuingCountry || "",
        }}
        validate={this.validateFormik}
        onChange={this.validateFormik}
        onSubmit={this.onUpdateAccount}>
        {({
          values,
          handleSubmit,
          handleChange,
          handleBlur,
          errors,
          setErrors,
          setFieldValue,
          validateForm,
        }) => (
          <Form onSubmit={handleSubmit}>
            <CardBody>
              <FormGroup row>
                <Label sm={3}>User account ID</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="accountId"
                    placeholder="Enter user's account id"
                    invalid={Boolean(errors.accountId)}
                    value={values.accountId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled
                  />
                  {errors.accountId && (
                    <FormFeedback className="text-alert">
                      {errors.accountId}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>First name</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="firstName"
                    placeholder="Enter user's first name"
                    invalid={Boolean(errors.firstName)}
                    value={values.firstName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.firstName && (
                    <FormFeedback className="text-alert">
                      {errors.firstName}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Last name</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="lastName"
                    placeholder="Enter user's last name"
                    invalid={Boolean(errors.lastName)}
                    value={values.lastName}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.lastName && (
                    <FormFeedback className="text-alert">
                      {errors.lastName}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>User photo</Label>
                <Col sm={9}>
                  <UploadButton
                    onSelectFile={userPhotoFile => {
                      setErrors({ ...errors, userPhotoFile: undefined });
                      this.onSelectUserPhoto(userPhotoFile);
                    }}
                    accept="image/png,image/jpeg"
                    maxFileSize={MAX_FILE_SIZE_IN_BYTES}
                  />
                  {errors.userPhotoFile && (
                    <FormFeedback className="text-alert">
                      {errors.userPhotoFile}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>ID photo</Label>
                <Col sm={9}>
                  <UploadButton
                    onSelectFile={idPhotoFile => {
                      setErrors({ ...errors, idPhotoFile: undefined });
                      this.onSelectUserID(idPhotoFile);
                    }}
                    accept="image/png,image/jpeg"
                    maxFileSize={MAX_FILE_SIZE_IN_BYTES}
                  />
                  {errors.idPhotoFile && (
                    <FormFeedback className="text-alert">
                      {errors.idPhotoFile}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Document ID</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="documentId"
                    placeholder="Enter user's document id"
                    invalid={Boolean(errors.documentId)}
                    value={values.documentId}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.documentId && (
                    <FormFeedback className="text-alert">
                      {errors.documentId}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Document Expiry</Label>
                <Col sm={9}>
                  <DatePicker
                    selected={values.documentExpiry}
                    placeholderText="MM/DD/YYYY"
                    isClearable
                    className="form-control"
                    wrapperClassName={datePickerWrapper}
                    onChange={date => setFieldValue("documentExpiry", date)}
                  />
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Date of birth</Label>
                <Col sm={9}>
                  <DatePicker
                    selected={
                      this.state.birthday ||
                      (birthday &&
                        new Date(
                          dateFormatter(birthday, {
                            showTime: false,
                            dateFormat: "array",
                            withoutUnknown: true,
                          }),
                        ))
                    }
                    className={{
                      "form-control": true,
                      "is-invalid": !!errors.birthday,
                    }}
                    wrapperClassName={datePickerWrapper}
                    onChange={date =>
                      this.onSelectDate(
                        date,
                        () => errors.birthday && validateForm(),
                      )
                    }
                  />
                  {errors.birthday && (
                    <FormFeedback className={displayBlock}>
                      {errors.birthday}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Nationality</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="nationality"
                    placeholder="Enter user's nationality"
                    invalid={Boolean(errors.nationality)}
                    value={values.nationality}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.nationality && (
                    <FormFeedback className="text-alert">
                      {errors.nationality}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              {IS_TOURIST_PG && (
                <FormGroup row>
                  <Label sm={3}>Issuing Country</Label>
                  <Col sm={9}>
                    <Input
                      type="text"
                      name="issuingCountry"
                      placeholder="ALPHA-3 CODE (E.G. KHM)"
                      maxLength={3}
                      invalid={Boolean(errors.issuingCountry)}
                      value={values.issuingCountry}
                      onChange={e =>
                        setFieldValue(
                          "issuingCountry",
                          e.target.value.toUpperCase(),
                        )
                      }
                      onBlur={handleBlur}
                    />
                    {errors.issuingCountry && (
                      <FormFeedback className="text-alert">
                        {errors.issuingCountry}
                      </FormFeedback>
                    )}
                  </Col>
                </FormGroup>
              )}
              <FormGroup row>
                <Label sm={3}>Secondary Contact</Label>
                <Col sm={9}>
                  {registeredType !== "SMS" && (
                    <InputMask
                      name="phoneNumber"
                      mask="+855 99 999 9999"
                      maskChar=""
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}>
                      {inputProps => (
                        <Input
                          type="text"
                          name="email"
                          placeholder="Enter user's secondary contact"
                          invalid={Boolean(errors.email)}
                        />
                      )}
                    </InputMask>
                  )}
                  {registeredType === "SMS" && (
                    <Input
                      type="text"
                      name="email"
                      placeholder="Enter user's secondary contact"
                      invalid={Boolean(errors.email)}
                      value={values.email}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                  )}
                  {errors.email && (
                    <FormFeedback className="text-alert">
                      {errors.email}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Home address</Label>
                <Col sm={9}>
                  <Input
                    type="text"
                    name="address"
                    placeholder="Enter user's address"
                    invalid={Boolean(errors.address)}
                    value={values.address}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  />
                  {errors.address && (
                    <FormFeedback className="text-alert">
                      {errors.address}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
              <FormGroup row>
                <Label sm={3}>Gender</Label>
                <Col sm={9}>
                  <Input
                    type="select"
                    name="sex"
                    placeholder="Enter user's gender"
                    invalid={Boolean(errors.sex)}
                    value={values.sex}
                    onChange={handleChange}
                    onBlur={handleBlur}>
                    <option value="male">Male</option>
                    <option value="female">Female</option>
                  </Input>
                  {errors.sex && (
                    <FormFeedback className="text-alert">
                      {errors.sex}
                    </FormFeedback>
                  )}
                </Col>
              </FormGroup>
            </CardBody>
            <CardFooter>
              <div className="buttons">
                <Button color="primary" type="submit">
                  <span>Update</span>
                </Button>
              </div>
            </CardFooter>
          </Form>
        )}
      </Formik>
    );

    return (
      <Modal
        isOpen={this.props.isOpen}
        onRequestClose={this.beforeClose}
        className={modalStyles}
        overlayClassName={overlayStyles}
        shouldCloseOnOverlayClick={false}
        shouldCloseOnEsc={false}>
        <Card>
          <CardHeader>
            <Button close onClick={this.beforeClose} />
            <span>Update account {this.props.data.accountId}</span>
          </CardHeader>
          {form}
        </Card>
      </Modal>
    );
  }
}

UpdateAccountModal.defaultProps = {
  isOpen: false,
  onModalClose: () => {},
  onUpdated: () => {},
  data: {},
};

UpdateAccountModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onModalClose: PropTypes.func.isRequired,
  onUpdated: PropTypes.func,
  data: PropTypes.object.isRequired,
};

export default UpdateAccountModal;
